import { useEffect, useState } from "react";
import { sql } from "../componentes/api.js";
import VerAnexosLista from "./VerAnexosLista.jsx";
import { Alert, Divider } from "@mui/material";
import TablaDesarrollo from "./TablaDesarrollo.jsx";
import Card from "react-bootstrap/Card";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import AlertTitle from "@mui/material/AlertTitle";
import Anexos from "./Anexos.jsx";

const SegBeneficiario = (props) => {
  /**Para cargar los datos de los combos */
  const [cargando, setCargando] = useState(false);
  const [idActividad, setIdActividad] = useState("");
  const [idProyectoActividad, setIdProyectoActividad] = useState();
  const [actividadesProyecto, setActividadesProyecto] = useState([]);
  const [requiereAnexo, setRequiereAnexo] = useState(0);
  const [cant, setCant] = useState(0);

  /***Para el manejo de la ventana para ver los anexos ****/
  const [verListaAnexos, setVerListaAnexos] = useState(false);

  useEffect(() => {
    if (props.idProyecto !== "") {
      setActividadesProyecto([]);
      cargarProyectoActividad(0);
    }
  }, [props.idProyecto]);

  const cargarProyectoActividad = async (filtro) => {
    try {
      setCargando(true);
      const response = await sql("getProyectoActividad", "POST", {
        idProyecto: props.idProyecto,
        tipoParticipante: 3,
        filtro: filtro,
      });
      if (response.length !== 0 && response.length !== "0") {
        setCant(response.length);
        setActividadesProyecto(response);
      } else {
        setCant(0);
        setActividadesProyecto([]);
      }
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const filtrar = (event) => {
    event.preventDefault();
    if (props.idBeneficiario !== "")
      cargarProyectoActividad(event.target.value);
    else props.mostrarMsg(["Por favor seleccione un Beneficiario"]);
  };

  const mostrarTabla = (idProyectoActividad, AnexosRequeridosMes) => {
    return (
      <TablaDesarrollo
        idProyectoActividad={idProyectoActividad}
        idParticipante={props.idBeneficiario}
        idUsuario={props.idUsuario}
        auditor={true}
        anexosRequeridos={AnexosRequeridosMes}
      />
    );
  };

  // const verAnexo = (event, idProyectoActividad, requiereAnexo, idActividad) => {
  //   event.preventDefault();
  //   setIdProyectoActividad(idProyectoActividad);
  //   setIdActividad(idActividad);
  //   setRequiereAnexo(requiereAnexo);
  //   setVerListaAnexos(true);
  // };

  return (
    <div className="container-fluid">
      <div className="row card mt-3 mb-3">
        <Alert severity="success">
          <strong>
            SEGUIMIENTO A LAS ACTIVIDADES DE PARTICIPANTES (BENEFICIARIOS)
          </strong>
        </Alert>

        <div className="row">
          <Alert severity="info">
            <AlertTitle>
              <strong>FILTRE LAS ACTIVIDADES QUE DESEA VER</strong>
              {cargando === true && (
                <div className="spinner-grow text-primary" role="status"></div>
              )}
            </AlertTitle>
            <br />
            <div
              className="btn-group"
              role="group"
              aria-label="Basic mixed styles example"
            >
              <button
                type="button"
                className="btn btn-dark"
                value={0}
                onClick={filtrar}
              >
                Todos
              </button>
              <button
                type="button"
                className="btn btn-danger"
                value={1}
                onClick={filtrar}
              >
                Pendientes
              </button>
              <button
                type="button"
                className="btn btn-warning"
                value={2}
                onClick={filtrar}
              >
                Para Revisión
              </button>
              <button
                type="button"
                className="btn btn-success"
                value={3}
                onClick={filtrar}
              >
                Devueltas
              </button>
              <button
                type="button"
                className="btn btn-primary"
                value={4}
                onClick={filtrar}
              >
                Con Visto Bueno
              </button>
            </div>
            <div className="form-text">
              Cantidad de Actividades encontradas {cant}
            </div>
            {cargando === true && (
              <div className="spinner-grow text-primary" role="status"></div>
            )}
          </Alert>
        </div>

        {/* {actividadesProyecto.toString().length > 0 && actividadesProyecto.map((reg, i)=>{ */}
        {actividadesProyecto.map((reg, i) => {
          return (
            <div className="row" key={i}>
              <Card>
                <Card.Body>
                  <Card.Title>
                    {i + 1}. {reg.Nbre}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {reg.TipoProyecto}
                  </Card.Subtitle>

                  <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                    <CalendarMonthIcon /> Actividad para realizarse desde el{" "}
                    {reg.FechaIni.toString().substring(0, 10)} al{" "}
                    {reg.FechaFin.toString().substring(0, 10)}
                  </Card.Subtitle>

                  {/* Zona para mirar los anexos de guías */}
                  {reg.TieneAnexos === 1 && (
                    <blockquote className="blockquote mb-0">
                      <p>
                        {" "}
                        <EmojiObjectsIcon /> Esta actividad contiene archivos
                        guías{" "}
                      </p>
                      <Anexos
                        Proyecto={props.idProyecto}
                        Actividad={reg.IdActividad}
                        llamador={props.tipoParticipante}
                      />
                      {/* <footer className="blockquote-footer">
                        <cite title="Source Title">
                          <Chip
                            label="Ver archivos anexos guías"
                            color="primary"
                            variant="outlined"
                            onClick={(event) =>
                              verAnexo(
                                event,
                                reg.Id,
                                reg.RequiereAnexo,
                                reg.IdActividad
                              )
                            }
                          />
                        </cite>
                      </footer> */}
                    </blockquote>
                  )}

                  <Divider className="mb-3 mt-3" />
                  {/* zona para adjuntar los anexos requeridos */}
                  {reg.AnexosRequeridosMes > 0 ? (
                    <div className="row mt-3">
                      {mostrarTabla(reg.Id, reg.AnexosRequeridosMes)}
                    </div>
                  ) : (
                    <Alert severity="success">
                      No requiere anexar archivos para esta Actividad!
                    </Alert>
                  )}
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>

      <VerAnexosLista
        verListaAnexos={verListaAnexos}
        setVerListaAnexos={setVerListaAnexos}
        idProyecto={props.idProyecto}
        idActividad={idActividad}
        idProyectoActividad={idProyectoActividad}
        //requiereAnexo={requiereAnexo}
        idUsuario={props.idUsuario}
      />
    </div>
  );
};

export default SegBeneficiario;
